import React from "react";
import { CurrencyRupeeIcon } from "@heroicons/react/outline";

const AmountInput = ({
  label,
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  showVariance = false,
  expectedAmount = 0,
  placeholder = "Enter amount",
}) => {
  const variance = expectedAmount > 0 
    ? ((value - expectedAmount) / expectedAmount) * 100 
    : 0;
    
  const hasVariance = showVariance && Math.abs(variance) > 0;
  const isHighVariance = Math.abs(variance) > 10;

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div className="mt-1 relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <CurrencyRupeeIcon className="h-5 w-5 text-gray-400" />
        </div>
        <input
          type="number"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          placeholder={placeholder}
          className={`block w-full pl-10 pr-3 py-2 border rounded-md focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm ${
            error ? "border-red-300" : "border-gray-300"
          } ${disabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
        />
      </div>
      
      {/* Variance Indicator */}
      {hasVariance && (
        <div className={`mt-1 text-xs ${isHighVariance ? "text-red-600" : "text-yellow-600"}`}>
          {variance > 0 ? "+" : ""}{variance.toFixed(1)}% variance from expected ₹{expectedAmount.toLocaleString()}
        </div>
      )}
      
      {/* Error Message */}
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default AmountInput;
